/* eslint-disable */

import React, { useEffect, useRef, useState } from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./pages/login/Login";
import Signup from "./pages/login/Signup";
import Recover from "./pages/recover/Recover";
import Dashboard from "./pages/dashboard/Dashboard2";
import Products from "./pages/products/Products";
import ProductsAi from "./pages/products/ProductsAi";
import Foorchat from "./pages/Foorchat/foorchat";
import Orders from "./pages/orders/Orders";
import Ordersabndn from "./pages/orders/Ordersabndn";
import OrdersAbndnSheet from "./pages/orders/OrdersAbndnSheet";
import OrderDetailsabndn from "./pages/orders/OrderDetailsabndn";
import Settings from "./pages/settings2/Settings";
import Account from "./pages/settings2/Account";
import AccountWorker from "./pages/worker/settings/Account.js";
import Store from "./pages/settings2/Store";
import Form from "./pages/settings2/form";
import Services from "./pages/settings2/Services";
import Shipcollect from "./pages/settings2/Shipcollect";
import Delevery from "./pages/settings2/Delevery";
import CountryCurrency from "./pages/settings2/countryCurrency";
import SocialMedia from "./pages/settings2/SocialMedia";
import Foorship from "./pages/pay/foorship";
import OrderSettings from "./pages/settings2/OrderSettings";
import Subscription from "./pages/settings2/subscription";
import Plan from "./pages/settings2/plan";
import Footer from "./pages/settings2/footer";

import Adduser from "./pages/confirmApp/adduser";
import FreeContent from "./pages/FreeContent";
import FoorAi from "./pages/FoorAi/FoorAi";
import CrossSell from "./pages/crossSell/crossSell.js";
import Editor from "./pages/FoorAi/editor.js";
import PaymentMethodsPage from "./pages/PaymentMethods/PaymentMethodsPage";
import DigitalSectionsPage from "./pages/DigitalSections/DigitalSections";
import WorkerStore from "./pages/worker/settings/Store.js";

import "./i18n";
import "./App.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  collection,
  query,
  where,
  limit,
  orderBy,
  getDocs,
  doc,
  onSnapshot,
  updateDoc,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "./firebase";
import { useDispatch } from "react-redux";
import { fetchProducts } from "./redux/products/products";
import { fetchCrossSell } from "./redux/crossSell/crossSell";
import { fetchStore } from "./redux/store/store";
import { fetchAccount } from "./redux/account/account";
import { fetchWorker } from "./redux/worker/worker";
import { fetchOrders } from "./redux/orders/orders";
import { fetchTransaction } from "./redux/transaction/transaction";
import { logoutUser } from "./redux/user/user";
import Domains from "./pages/domains/Domains";
import OrderProfile from "./pages/orders/OrderProfile";
import WorkerOrderProfile from "./pages/worker/orders/OrderProfile";
import Stock from "./pages/settings2/Stock";
import WorkerStock from "./pages/worker/settings/Stock.js";
import { fetchNotification } from "./redux/notification/notification";
import disableDevtool from "disable-devtool";
import DigitalOrders from "./pages/orders/DigitalOrders";
import DigitalOrderProfile from "./pages/orders/DigitalOrderProfile";
import DigitalForm from "./pages/settings2/digitalForm";
import DigitalCurrency from "./pages/settings2/digitalCurrency";
import Chat from "./pages/chat/chat.js";
import { fetchDigitalStore } from "./redux/digitalStore/digitalStore.js";
import DigitalStore from "./pages/settings2/DigitalStore.js";
import DigitalOrderSettings from "./pages/settings2/DigitalOrderSettings.js";
import DigitalSocialMedia from "./pages/settings2/DigitalSocialMedia.js";
import DigitalPlan from "./pages/settings2/DigitalPlan.js";
import WorkersManagement from "./pages/workersManagement/workers_management_dashboard.js";
import SpecialOffer from "./pages/specialOffer/SpecialOffer";
import ProfitManagement from "./pages/settings2/ProfitManagement";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FloatingDiscountTimer from "./components/FloatingDiscountTimer";
import UploadValidationModal from "./components/ValidationDhd";

import { useTranslation } from "react-i18next";
import WorkerDashboard from "./pages/worker/dashboard/WorkerDashboard.js";
import WorkerOrders from "./pages/worker/orders/Orders.js";
import WorkerOrdersabndn from "./pages/worker/orders/WorkerOrdersabndn.js";
import WorkerProducts from "./pages/worker/products/Products.js";
import WorkerSettingsPage from "./pages/worker/settings/Settings.js";
import workerAPI from "./api/worker/worker_service.js";
import OrderStatistics from "./pages/orders/OrderStatistics";
import DeliveryCompanySync from "./components/DeliveryCompanySync";

import { X } from "lucide-react";

// ai product generation
import {
  AIProductGenerationProvider,
  useAIGeneration,
} from "./context/AIProductGenerationContext";
import MinimizedOrb from "./components/products/model/MinimizedOrb";

// dhd warnings
import DhdWarningModal from "./components/DhdWarningModal";
import { getDhdForm, pickActiveDhdWarning } from "./utils/dhdHelpers";
// ------------------------------------------------------------------
// Welcome video now plays from YouTube instead of a direct <video> src.
// Replace this with your own video ID (the part after "v=" or after
// "youtu.be/" in the YouTube URL).
// ------------------------------------------------------------------
const YOUTUBE_VIDEO_ID = "RaBTOkmzIw4"; // https://youtu.be/RaBTOkmzIw4?si=8RmQjssLP2HCKs58
const WORKSHOP_YOUTUBE_VIDEO_ID = "RZIktDroE7w"; // https://youtu.be/RZIktDroE7w?si=wMvdDRcc2JrTEKgW

const SKIP_UNLOCK_SECONDS = 15;
const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

// dhd form
const TWO_DAYS_MS = 2 * 24 * 60 * 60 * 1000;

let ytApiPromise = null;
const loadYouTubeIframeAPI = () => {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (ytApiPromise) return ytApiPromise;

  ytApiPromise = new Promise((resolve) => {
    const prevCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (prevCallback) prevCallback();
      resolve(window.YT);
    };
    if (
      !document.querySelector(
        'script[src="https://www.youtube.com/iframe_api"]',
      )
    ) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
    }
  });
  return ytApiPromise;
};

// Wrapper component to use useNavigate inside Router context
const FloatingDiscountTimerWrapper = (props) => {
  const navigate = useNavigate();
  return <FloatingDiscountTimer {...props} onNavigate={navigate} />;
};

const getWelcomeVideoState = (accountData) => {
  const wv = accountData?.welcomeVideo || {};

  let lastSeenAt = null;
  if (wv.lastSeenAt) {
    if (typeof wv.lastSeenAt.toDate === "function") {
      lastSeenAt = wv.lastSeenAt.toDate();
    } else if (wv.lastSeenAt instanceof Date) {
      lastSeenAt = wv.lastSeenAt;
    } else if (typeof wv.lastSeenAt.seconds === "number") {
      lastSeenAt = new Date(wv.lastSeenAt.seconds * 1000);
    }
  }

  return {
    lastSeenAt,
    skipCount: typeof wv.skipCount === "number" ? wv.skipCount : 0,
  };
};

const shouldShowWelcomeVideo = (accountData) => {
  const { lastSeenAt, skipCount } = getWelcomeVideoState(accountData);

  if (!lastSeenAt) return true; // never dismissed before

  const elapsed = Date.now() - lastSeenAt.getTime();

  if (skipCount === 1) {
    // after first skip: 3 days
    return elapsed >= THREE_DAYS_MS;
  }

  return elapsed >= ONE_WEEK_MS; // after second skip: weekly
};

// const WelcomeVideoModal = ({
//   isOpen,
//   onClose,
//   isMinimized,
//   onMinimize,
//   onExpand,
// }) => {
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const playerContainerRef = useRef(null);
//   const playerRef = useRef(null);
//   const progressIntervalRef = useRef(null);

//   const [progress, setProgress] = useState(0);
//   const [elapsed, setElapsed] = useState(0);
//   const [canSkip, setCanSkip] = useState(false);
//   const [isHovering, setIsHovering] = useState(false);
//   const [isLoading, setIsLoading] = useState(true);
//   const [hasStarted, setHasStarted] = useState(false);

//   const secondsLeft = Math.max(0, Math.ceil(SKIP_UNLOCK_SECONDS - elapsed));

//   // Lock body scroll only when fully open
//   useEffect(() => {
//     document.body.style.overflow = isOpen && !isMinimized ? "hidden" : "";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [isOpen, isMinimized]);

//   // Create the YouTube player once, when the modal opens
//   useEffect(() => {
//     if (!isOpen) return;

//     let cancelled = false;

//     loadYouTubeIframeAPI().then((YT) => {
//       if (cancelled || !playerContainerRef.current || playerRef.current) return;

//       playerRef.current = new YT.Player(playerContainerRef.current, {
//         videoId: YOUTUBE_VIDEO_ID,
//         playerVars: {
//           autoplay: 0,
//           controls: 0,
//           disablekb: 1,
//           modestbranding: 1,
//           rel: 0,
//           playsinline: 1,
//           mute: 1,
//           loop: 1,
//           playlist: YOUTUBE_VIDEO_ID,
//         },
//         events: {
//           onReady: () => setIsLoading(false),
//           onStateChange: (e) => {
//             if (e.data === YT.PlayerState.PLAYING) {
//               setIsLoading(false);
//               if (!progressIntervalRef.current) {
//                 progressIntervalRef.current = setInterval(() => {
//                   const player = playerRef.current;
//                   if (!player || !player.getDuration) return;
//                   const duration = player.getDuration();
//                   const current = player.getCurrentTime();
//                   if (!duration) return;
//                   setElapsed(current);
//                   setProgress((current / duration) * 100);
//                   if (current >= SKIP_UNLOCK_SECONDS) setCanSkip(true);
//                 }, 250);
//               }
//             }
//             if (e.data === YT.PlayerState.BUFFERING) setIsLoading(true);
//           },
//         },
//       });
//     });

//     return () => {
//       cancelled = true;
//       if (progressIntervalRef.current) {
//         clearInterval(progressIntervalRef.current);
//         progressIntervalRef.current = null;
//       }
//       if (playerRef.current) {
//         playerRef.current.destroy();
//         playerRef.current = null;
//       }
//       setHasStarted(false);
//       setIsLoading(true);
//       setProgress(0);
//       setElapsed(0);
//       setCanSkip(false);
//     };
//   }, [isOpen]);

//   // Play/pause according to open + minimized state
//   useEffect(() => {
//     const player = playerRef.current;
//     if (!player || !hasStarted) return;
//     if (isOpen && player.playVideo) player.playVideo();
//   }, [isOpen, isMinimized, hasStarted]);

//   if (!isOpen) return null;

//   const handleSkip = () => onClose();

//   const handleKnowMore = () => {
//     onMinimize();
//     navigate("/foorcall");
//   };

//   const handleStartVideo = () => {
//     const player = playerRef.current;
//     if (!player) return;
//     player.unMute();
//     player.seekTo(0);
//     player.playVideo();
//     setHasStarted(true);
//   };

//   const handleContainerClick = (e) => {
//     if (isMinimized && !e.target.closest("button")) {
//       onExpand();
//     }
//   };

//   return (
//     <>
//        <div
//         className={`fixed inset-0 z-[9998] bg-black/65 backdrop-blur-[3px] transition-opacity duration-500 ${
//           isMinimized ? "opacity-0 pointer-events-none" : "opacity-100"
//         }`}
//         />

//        <div
//         onClick={handleContainerClick}
//         onMouseEnter={() => setIsHovering(true)}
//         onMouseLeave={() => setIsHovering(false)}
//         className={`
//           fixed z-[9999] overflow-hidden bg-black shadow-2xl cursor-pointer
//           transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]
//           ${
//             isMinimized
//               ? "bottom-[74px] left-4 w-[280px] max-w-[calc(100vw-2rem)] rounded-xl aspect-video"
//               : "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 " +
//                 "w-[92vw] sm:w-[80vw] md:w-[60vw] lg:w-[45vw] xl:w-[38vw] " +
//                 "max-w-[640px] rounded-xl sm:rounded-2xl aspect-video"
//           }
//         `}
//         style={{
//           transform: isMinimized ? "none" : "translate(-50%, -50%)",
//         }}
//        >
//         {!hasStarted && !isMinimized && (
//           <button
//             onClick={handleStartVideo}
//             className="absolute inset-0 z-30 flex items-center justify-center bg-black/40"
//           >
//             <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg hover:scale-105 transition">
//               <svg
//                 width="28"
//                 height="28"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//               >
//                 <polygon points="8,5 19,12 8,19" />
//               </svg>
//             </div>
//           </button>
//         )}

//         <div
//           ref={playerContainerRef}
//           className="w-full h-full pointer-events-none"
//         />

//         {isLoading && (
//           <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/50">
//             <div
//               className="w-12 h-12 rounded-full border-[3px] border-white/25 border-t-[#9b59bf] animate-spin"
//               aria-label="loading"
//             />
//           </div>
//         )}

//         {!isMinimized && (
//           <div
//             className="absolute inset-0 pointer-events-none transition-shadow duration-300"
//             style={{
//               boxShadow: isHovering
//                 ? "inset 0 0 90px 25px rgba(0,0,0,0.55)"
//                 : "inset 0 0 0 0 rgba(0,0,0,0)",
//             }}
//           />
//         )}

//         {!isMinimized && (
//           <>
//             <button
//               onClick={handleKnowMore}
//               className="absolute top-4 left-4 z-20 text-white text-sm font-medium bg-black/50 hover:bg-black/70 px-3 py-1.5 rounded-md backdrop-blur-sm transition-all"
//             >
//               {t("video.knowMore")}
//             </button>

//             <div className="absolute bottom-6 right-4 z-20">
//               {canSkip ? (
//                 <button
//                   onClick={handleSkip}
//                   className="flex items-center gap-1.5 bg-black/70 hover:bg-black/85 text-white text-sm font-semibold px-4 py-2 rounded-sm transition-all"
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="14"
//                     height="14"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <polyline points="9 18 15 12 9 6" />
//                   </svg>
//                   {t("video.skip")}
//                 </button>
//               ) : (
//                 <div className="bg-black/60 text-white text-sm font-medium px-4 py-2 rounded-sm">
//                   {t("video.skipIn")} {secondsLeft}
//                 </div>
//               )}
//             </div>
//           </>
//         )}

//         {isMinimized && (
//           <>
//             <div
//               className={`absolute inset-0 bg-black/40 transition-opacity duration-300 pointer-events-none ${
//                 isHovering ? "opacity-100" : "opacity-0"
//               }`}
//             />

//             <button
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onClose();
//               }}
//               className="absolute top-2 right-2 z-20 w-7 h-7 flex items-center justify-center rounded-full bg-black/60 hover:bg-black/80 text-white transition-all"
//               aria-label="Close"
//             >
//               <X size={14} />
//             </button>

//             <div
//               className={`absolute inset-0 flex items-center justify-center z-10 transition-opacity duration-300 pointer-events-none ${
//                 isHovering ? "opacity-100" : "opacity-0"
//               }`}
//             >
//               <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="white"
//                   strokeWidth="2.2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <polyline points="15 3 21 3 21 9" />
//                   <polyline points="9 21 3 21 3 15" />
//                   <line x1="21" y1="3" x2="14" y2="10" />
//                   <line x1="3" y1="21" x2="10" y2="14" />
//                 </svg>
//               </div>
//             </div>
//           </>
//         )}

//         <div
//           className={`absolute bottom-0 left-0 w-full bg-white/20 z-20 transition-all duration-150 ${
//             isMinimized ? "h-[3px]" : isHovering ? "h-[6px]" : "h-[3px]"
//           }`}
//         >
//           <div
//             className="h-full bg-[#9b59bf] transition-[width] duration-150"
//             style={{ width: `${progress}%` }}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

function WorkshopSkipConfirmDialog({ t, isRTL, onStay, onLeave }) {
  return (
    <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/50 p-4">
      <div
        dir={isRTL ? "rtl" : "ltr"}
        className="w-full max-w-sm bg-white rounded-2xl shadow-2xl p-5 sm:p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-base font-bold text-gray-900 mb-2">
          {t("video.workshop.skipConfirmTitle")}
        </h3>
        <p className="text-sm text-gray-500 leading-relaxed mb-5">
          {t("video.workshop.skipConfirmBody")}
        </p>
        <div className="flex items-center gap-2">
          <button
            onClick={onStay}
            className="flex-1 h-11 rounded-xl bg-[#9b59bf] hover:bg-[#814a9f] text-white text-sm font-semibold transition-colors"
          >
            {t("video.workshop.cancel")}
          </button>
          <button
            onClick={onLeave}
            className="flex-1 h-11 rounded-xl border border-red-200 text-red-600 text-sm font-semibold hover:bg-red-50 transition-colors"
          >
            {t("video.workshop.skip")}
          </button>
        </div>
      </div>
    </div>
  );
}

const WorkshopVideoModal = ({
  isOpen,
  onClose,
  isMinimized,
  onMinimize,
  onExpand,
}) => {
  const { t, i18n } = useTranslation();
  const playerContainerRef = useRef(null);
  const playerRef = useRef(null);
  const progressIntervalRef = useRef(null);

  const [progress, setProgress] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasStarted, setHasStarted] = useState(false);

  const [isPlaying, setIsPlaying] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showSkipConfirm, setShowSkipConfirm] = useState(false);

  // lock body scroll only when fully open
  useEffect(() => {
    document.body.style.overflow = isOpen && !isMinimized ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen, isMinimized]);

  // create youTube player once (when the modal opens)
  useEffect(() => {
    if (!isOpen) return;

    let cancelled = false;

    loadYouTubeIframeAPI().then((YT) => {
      if (cancelled || !playerContainerRef.current || playerRef.current) return;

      playerRef.current = new YT.Player(playerContainerRef.current, {
        videoId: WORKSHOP_YOUTUBE_VIDEO_ID,
        playerVars: {
          autoplay: 0,
          controls: 0,
          disablekb: 1,
          modestbranding: 1,
          rel: 0,
          playsinline: 1,
          mute: 1,
          loop: 1,
          playlist: WORKSHOP_YOUTUBE_VIDEO_ID,
        },
        events: {
          onReady: () => setIsLoading(false),
          onStateChange: (e) => {
            if (e.data === YT.PlayerState.PLAYING) {
              setIsLoading(false);
              setIsPlaying(true);
              if (!progressIntervalRef.current) {
                progressIntervalRef.current = setInterval(() => {
                  const player = playerRef.current;
                  if (!player || !player.getDuration) return;
                  const duration = player.getDuration();
                  const current = player.getCurrentTime();
                  if (!duration) return;
                  setProgress((current / duration) * 100);
                }, 250);
              }
            }
            if (e.data === YT.PlayerState.PAUSED) {
              setIsPlaying(false);
            }
            if (e.data === YT.PlayerState.ENDED) {
              setIsPlaying(false);
            }
            if (e.data === YT.PlayerState.BUFFERING) setIsLoading(true);
          },
        },
      });
    });

    return () => {
      cancelled = true;
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = null;
      }
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
      setHasStarted(false);
      setIsLoading(true);
      setProgress(0);
      setIsPlaying(false);
    };
  }, [isOpen]);

  // play/pause according to open and minimized state
  useEffect(() => {
    const player = playerRef.current;
    if (!player || !hasStarted) return;
    if (isOpen && player.playVideo) player.playVideo();
  }, [isOpen, isMinimized, hasStarted]);

  // keep isFullscreen in sync if user presses Esc
  useEffect(() => {
    const onFsChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", onFsChange);
    return () => document.removeEventListener("fullscreenchange", onFsChange);
  }, []);

  if (!isOpen) return null;

  const handleSkipClick = () => {
    setShowMenu(false);
    const player = playerRef.current;
    if (player && player.pauseVideo) {
      player.pauseVideo();
    }
    setShowSkipConfirm(true);
  };

  const handleConfirmSkip = () => {
    setShowSkipConfirm(false);
    onClose("skip");
  };

  const handleCancelSkip = () => {
    setShowSkipConfirm(false);
    const player = playerRef.current;
    if (player && hasStarted && player.playVideo) {
      player.playVideo();
    }
  };

  const handleWatchLater = () => {
    setShowMenu(false);
    onClose("watchLater");
  };

  const handleKnowMore = () => {
    window.open(
      `https://www.youtube.com/watch?v=${WORKSHOP_YOUTUBE_VIDEO_ID}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleContainerClick = (e) => {
    if (isMinimized && !e.target.closest("button")) {
      onExpand();
    }
  };

  const handleTogglePlay = (e) => {
    e.stopPropagation();
    const player = playerRef.current;
    if (!player) return;

    if (isPlaying) {
      player.pauseVideo();
    } else {
      if (!hasStarted) {
        player.unMute();
        player.seekTo(0);
        setHasStarted(true);
      }
      player.playVideo();
    }
  };

  const handleToggleFullscreen = async (e) => {
    e.stopPropagation();
    const el = containerRef.current;
    if (!el) return;

    try {
      if (!document.fullscreenElement) {
        await el.requestFullscreen();
        setIsFullscreen(true);
      } else {
        await document.exitFullscreen();
        setIsFullscreen(false);
      }
    } catch (err) {
      console.error("Fullscreen error:", err);
    }
  };

  return (
    <>
      <div
        className={`fixed inset-0 z-[9998] bg-black/65 backdrop-blur-[3px] transition-opacity duration-500 ${
          isMinimized ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      />

      <div
        ref={containerRef}
        onClick={(e) => {
          setShowMenu(false);
          handleContainerClick(e);
        }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        className={`
          fixed z-[9999] overflow-hidden bg-black shadow-2xl cursor-pointer
          transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]
          ${
            isFullscreen
              ? "inset-0 w-screen h-screen rounded-none aspect-auto"
              : isMinimized
                ? "bottom-[74px] left-4 w-[280px] max-w-[calc(100vw-2rem)] rounded-xl aspect-video"
                : "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 " +
                  "w-[92vw] sm:w-[80vw] md:w-[60vw] lg:w-[45vw] xl:w-[38vw] " +
                  "max-w-[640px] rounded-xl sm:rounded-2xl aspect-video"
          }
        `}
        style={{
          transform:
            isMinimized || isFullscreen ? "none" : "translate(-50%, -50%)",
        }}
      >
        <button
          onClick={handleTogglePlay}
          className={`absolute inset-0 z-30 flex items-center justify-center bg-black/40 transition-opacity duration-200 ${
            !hasStarted && !isMinimized
              ? "opacity-100 pointer-events-auto"
              : "opacity-0 pointer-events-none"
          }`}
          tabIndex={!hasStarted && !isMinimized ? 0 : -1}
          aria-hidden={hasStarted || isMinimized}
        >
          <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg hover:scale-105 transition">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="8,5 19,12 8,19" />
            </svg>
          </div>
        </button>

        <div className="absolute inset-0 w-full h-full pointer-events-none">
          <div ref={playerContainerRef} className="w-full h-full" />
        </div>

        {isLoading && (
          <div className="absolute inset-0 z-30 flex items-center justify-center bg-black/50">
            <div
              className="w-12 h-12 rounded-full border-[3px] border-white/25 border-t-[#9b59bf] animate-spin"
              aria-label={t("ui.loading")}
            />
          </div>
        )}

        {!isMinimized && (
          <div
            className="absolute inset-0 pointer-events-none transition-shadow duration-300"
            style={{
              boxShadow: isHovering
                ? "inset 0 0 90px 25px rgba(0,0,0,0.55)"
                : "inset 0 0 0 0 rgba(0,0,0,0)",
            }}
          />
        )}

        {!isMinimized && !isFullscreen && (
          <>
            <button
              onClick={handleKnowMore}
              className="absolute top-4 left-4 z-20 text-white text-sm font-medium bg-black/50 hover:bg-black/70 px-3 py-1.5 rounded-md backdrop-blur-sm transition-all"
            >
              {t("video.knowMore")}
            </button>

            {!isMinimized && !isFullscreen && (
              <div className="absolute bottom-5 right-4 z-30">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowMenu((prev) => !prev);
                  }}
                  className="w-10 h-10 rounded-full bg-black/70 hover:bg-black/90 text-white flex items-center justify-center transition"
                  aria-label={t("orders.options")}
                >
                  <div className="relative w-5 h-5">
                    {/* top line */}
                    <span
                      className={`absolute left-0 top-1/2 h-[2px] w-full -translate-y-1/2 rounded-full bg-white transition-all duration-300 origin-center ${
                        showMenu ? "rotate-45" : "-translate-y-[7px]"
                      }`}
                    />
                    {/* middle line */}
                    <span
                      className={`absolute left-0 top-1/2 h-[2px] w-full -translate-y-1/2 rounded-full bg-white transition-all duration-300 ${
                        showMenu ? "opacity-0 scale-x-0" : ""
                      }`}
                    />
                    {/* bottom line */}
                    <span
                      className={`absolute left-0 top-1/2 h-[2px] w-full -translate-y-1/2 rounded-full bg-white transition-all duration-300 origin-center ${
                        showMenu ? "-rotate-45" : "translate-y-[7px]"
                      }`}
                    />
                  </div>
                </button>

                {showMenu && (
                  <div
                    className="absolute bottom-12 right-0 w-44 bg-[#212121] rounded-xl shadow-xl overflow-hidden border border-white/10"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      onClick={handleWatchLater}
                      className="w-full text-left px-4 py-3 text-sm text-white hover:bg-white/10 transition"
                    >
                      {t("video.workshop.watchLater")}
                    </button>
                    <button
                      onClick={handleSkipClick}
                      className="w-full text-left px-4 py-3 text-sm text-white hover:bg-white/10 transition border-t border-white/10"
                    >
                      {t("video.workshop.skip")}
                    </button>
                  </div>
                )}
              </div>
            )}
          </>
        )}

        {isMinimized && (
          <>
            <div
              className={`absolute inset-0 bg-black/40 transition-opacity duration-300 pointer-events-none ${
                isHovering ? "opacity-100" : "opacity-0"
              }`}
            />

            <button
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              className="absolute top-2 right-2 z-20 w-7 h-7 flex items-center justify-center rounded-full bg-black/60 hover:bg-black/80 text-white transition-all"
              aria-label={t("video.close")}
            >
              <X size={14} />
            </button>

            <div
              className={`absolute inset-0 flex items-center justify-center z-10 transition-opacity duration-300 pointer-events-none ${
                isHovering ? "opacity-100" : "opacity-0"
              }`}
            >
              <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="15 3 21 3 21 9" />
                  <polyline points="9 21 3 21 3 15" />
                  <line x1="21" y1="3" x2="14" y2="10" />
                  <line x1="3" y1="21" x2="10" y2="14" />
                </svg>
              </div>
            </div>
          </>
        )}

        {/* play/pause, full screen, minimize */}
        {!isMinimized && (
          <div
            className={`absolute bottom-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3
              transition-opacity duration-200 ${
                isHovering || !hasStarted ? "opacity-100" : "opacity-0"
              }`}
          >
            {/* play/pause */}
            <button
              onClick={handleTogglePlay}
              className="w-10 h-10 rounded-full bg-black/70 hover:bg-black/90 text-white flex items-center justify-center transition"
              aria-label={isPlaying ? t("ui.pause") : t("ui.play")}
            >
              {isPlaying ? (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <rect x="6" y="4" width="4" height="16" rx="1" />
                  <rect x="14" y="4" width="4" height="16" rx="1" />
                </svg>
              ) : (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <polygon points="8,5 19,12 8,19" />
                </svg>
              )}
            </button>

            {/* full screen */}
            <button
              onClick={handleToggleFullscreen}
              className="w-10 h-10 rounded-full bg-black/70 hover:bg-black/90 text-white flex items-center justify-center transition"
              aria-label={isFullscreen ? t("ui.exitFullscreen") : t("ui.fullscreen")}
            >
              {isFullscreen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="4 14 10 14 10 20" />
                  <polyline points="20 10 14 10 14 4" />
                  <line x1="14" y1="10" x2="21" y2="3" />
                  <line x1="3" y1="21" x2="10" y2="14" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="15 3 21 3 21 9" />
                  <polyline points="9 21 3 21 3 15" />
                  <line x1="21" y1="3" x2="14" y2="10" />
                  <line x1="3" y1="21" x2="10" y2="14" />
                </svg>
              )}
            </button>

            {/* minimize (picture in picture style) */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                if (document.fullscreenElement) {
                  document.exitFullscreen().catch(() => {});
                }
                onMinimize();
              }}
              className="w-10 h-10 rounded-full bg-black/70 hover:bg-black/90 text-white flex items-center justify-center transition"
              aria-label={t("Products.advertorial.minimize")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="4 14 10 14 10 20" />
                <polyline points="20 10 14 10 14 4" />
                <line x1="14" y1="10" x2="21" y2="3" />
                <line x1="3" y1="21" x2="10" y2="14" />
              </svg>
            </button>
          </div>
        )}

        <div
          className={`absolute bottom-0 left-0 w-full bg-white/20 z-20 transition-all duration-150 ${
            isMinimized ? "h-[3px]" : isHovering ? "h-[6px]" : "h-[3px]"
          }`}
        >
          <div
            className="h-full bg-[#9b59bf] transition-[width] duration-150"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
      {showSkipConfirm && (
        <WorkshopSkipConfirmDialog
          t={t}
          isRTL={i18n.language === "ar"}
          onStay={handleCancelSkip}
          onLeave={handleConfirmSkip}
        />
      )}
    </>
  );
};

// ai product generation
function GenerationOrbHost() {
  const navigate = useNavigate();
  const { isMinimized, phase, fillProgress, expand, generationFeature } =
    useAIGeneration();
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  if (!isMinimized || (phase !== "generating" && phase !== "done")) return null;

  const handleExpand = () => {
    expand();
    navigate(generationFeature === "landing_page" ? "/landing-page" : "/products");
  };

  return (
    <MinimizedOrb
      progress={fillProgress}
      done={phase === "done"}
      onExpand={handleExpand}
      isRTL={isRTL}
    />
  );
}

// dhd form helpers
const getDhdReminderState = (formData) => {
  const raw = formData?.lastReminderAt;
  let lastReminderAt = null;
  if (raw) {
    if (typeof raw.toDate === "function") lastReminderAt = raw.toDate();
    else if (raw instanceof Date) lastReminderAt = raw;
    else if (typeof raw.seconds === "number")
      lastReminderAt = new Date(raw.seconds * 1000);
  }
  return { lastReminderAt };
};

const isDhdApplicationIncomplete = (formData) => {
  if (!formData) return false;
  if (formData.finished === true) return false;
  if (formData.status === "approved") return false;
  return (
    formData.acceptDHD === true ||
    typeof formData.currentStep === "number" ||
    formData.pdfDownloaded === true
  );
};

const shouldShowDhdReminder = (formData) => {
  if (!isDhdApplicationIncomplete(formData)) return false;
  const { lastReminderAt } = getDhdReminderState(formData);
  if (!lastReminderAt) return true;
  return Date.now() - lastReminderAt.getTime() >= TWO_DAYS_MS;
};

const DhdReminderModalWrapper = ({ isOpen, onSkip }) => {
  const navigate = useNavigate();

  const handleContinue = async () => {
    await onSkip();
    navigate("/special-offer");
  };

  return (
    <DhdReminderModal
      isOpen={isOpen}
      onContinue={handleContinue}
      onSkip={onSkip}
    />
  );
};

const DhdReminderModal = ({ isOpen, onContinue, onSkip }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[10050] flex items-center justify-center p-4"
      style={{
        background: "rgba(15, 5, 25, 0.72)",
        backdropFilter: "blur(6px)",
      }}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div
        className="w-full max-w-md overflow-hidden rounded-3xl shadow-2xl"
        style={{
          background:
            "linear-gradient(165deg, #1a0a00 0%, #2a1208 45%, #1a1025 100%)",
          border: "1px solid rgba(255, 106, 0, 0.35)",
          animation: "dhdReminderIn 0.28s ease-out",
        }}
      >
        <div className="relative px-6 pt-6 pb-4 overflow-hidden">
          <div
            className="absolute inset-0 pointer-events-none opacity-40"
            style={{
              background:
                "radial-gradient(ellipse 70% 80% at 20% 0%, rgba(255,106,0,0.35), transparent 55%), radial-gradient(ellipse 50% 60% at 90% 100%, rgba(155,89,191,0.25), transparent 50%)",
            }}
          />
          <div className="relative flex items-center gap-3">
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 overflow-hidden"
              style={{
                background: "rgba(255,106,0,0.15)",
                border: "1px solid rgba(255,106,0,0.35)",
              }}
            >
              <img
                src="/dhd.png"
                alt="DHD"
                className="w-10 h-10 object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.parentElement.innerHTML =
                    '<span style="color:#FF6A00;font-weight:900;font-size:14px">DHD</span>';
                }}
              />
            </div>
            <div>
              <div
                className="text-[11px] font-bold tracking-widest uppercase"
                style={{ color: "rgba(255,106,0,0.9)" }}
              >
                DHD × FoorWeb
              </div>
              <h3 className="text-white text-lg font-black leading-tight mt-0.5">
                {t("dhdReminder.title")}
              </h3>
            </div>
          </div>
        </div>

        <div className="px-6 pb-6 relative">
          <p
            className="text-sm leading-relaxed mb-5"
            style={{ color: "rgba(255,255,255,0.72)" }}
          >
            {t("dhdReminder.description")}
          </p>

          <div
            className="rounded-2xl p-3.5 mb-5 text-xs font-semibold"
            style={{
              background: "rgba(155,89,191,0.12)",
              border: "1px solid rgba(155,89,191,0.28)",
              color: "rgba(255,255,255,0.85)",
            }}
          >
            {t("dhdReminder.hint")}
          </div>

          <div className="flex flex-col gap-2.5">
            <button
              type="button"
              onClick={onContinue}
              className="w-full h-12 rounded-2xl font-bold text-sm transition active:scale-[0.98]"
              style={{
                background: "linear-gradient(90deg, #FF6A00, #9b59bf)",
                color: "#fff",
                boxShadow: "0 10px 28px rgba(255,106,0,0.25)",
              }}
            >
              {t("dhdReminder.continue")}
            </button>
            <button
              type="button"
              onClick={onSkip}
              className="w-full h-11 rounded-2xl font-semibold text-sm transition"
              style={{
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.12)",
                color: "rgba(255,255,255,0.75)",
              }}
            >
              {t("dhdReminder.skip")}
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes dhdReminderIn {
          from { opacity: 0; transform: scale(0.94) translateY(12px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
};

function App() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userReducer.user);
  const account = useSelector((state) => state.AccountReducer);
  const worker = useSelector((state) => state.workerReducer);
  const [userType, setUserType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [dhdFormData, setDhdFormData] = useState(null);
  const [dhdFormDate, setDhdFormDate] = useState(null);
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);

  // foorcall video ads
  const [showWelcomeVideo, setShowWelcomeVideo] = useState(false);
  const hasCheckedWelcomeVideo = useRef(false);
  const [isWelcomeVideoMinimized, setIsWelcomeVideoMinimized] = useState(false);

  // workshop video
  const [showWorkshopVideo, setShowWorkshopVideo] = useState(false);
  const hasCheckedWorkshopVideo = useRef(false);
  const [isWorkshopVideoMinimized, setIsWorkshopVideoMinimized] =
    useState(false);

  const storeUnsubRef = useRef(null);

  // dhd form reminder
  const [showDhdReminder, setShowDhdReminder] = useState(false);

  // dhd warnings
  const [activeWarning, setActiveWarning] = useState(null);
  const [warningUserId, setWarningUserId] = useState(null);

  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const auth = getAuth();
  const threeDaysAgo = Timestamp.fromDate(
    new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
  );
  const current_timestamp = Timestamp.fromDate(new Date());
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const oneWeekAgoTimestamp = Timestamp.fromDate(oneWeekAgo);

  const checkFoorcallActive = async (userId) => {
    try {
      const q = query(collection(db, "foorcall"), where("user", "==", userId));
      const snapshot = await getDocs(q);

      if (snapshot.empty) return false;

      const docs = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

      const latest = docs.sort((a, b) => {
        const dateA = a?.createdAt?.seconds || 0;
        const dateB = b?.createdAt?.seconds || 0;
        return dateB - dateA;
      })[0];

      return !!latest?.activeFoorcallSeller;
    } catch (error) {
      console.error("Error checking foorcall status:", error);
      return false;
    }
  };

  const handleCloseWelcomeVideo = async () => {
    setShowWelcomeVideo(false);
    setIsWelcomeVideoMinimized(false);

    // you already have the uid in `user`
    const uid =
      typeof user === "string" ? user : user?.uid || getAuth().currentUser?.uid;

    if (!uid) {
      console.error("No user uid available");
      return;
    }

    try {
      const currentSkipCount =
        typeof account?.welcomeVideo?.skipCount === "number"
          ? account.welcomeVideo.skipCount
          : 0;

      if (!account?.id) {
        console.error("[closeVideo] account.id missing, aborting", account);
        return;
      }
      await updateDoc(doc(db, "account", account.id), {
        welcomeVideo: {
          videoSrc: YOUTUBE_VIDEO_ID,
          lastSeenAt: serverTimestamp(),
          skipCount: currentSkipCount + 1,
        },
      });
    } catch (err) {
      console.error("Failed to save welcome video state:", err);
    }
  };

  const handleMinimizeWelcomeVideo = () => {
    setIsWelcomeVideoMinimized(true);
  };

  const handleExpandWelcomeVideo = () => {
    setIsWelcomeVideoMinimized(false);
  };

  const getWorkshopVideoState = (accountData) => {
    const wv = accountData?.workshopVideo || {};
    let lastSeenAt = null;
    if (wv.lastSeenAt) {
      if (typeof wv.lastSeenAt.toDate === "function")
        lastSeenAt = wv.lastSeenAt.toDate();
      else if (wv.lastSeenAt instanceof Date) lastSeenAt = wv.lastSeenAt;
      else if (typeof wv.lastSeenAt.seconds === "number")
        lastSeenAt = new Date(wv.lastSeenAt.seconds * 1000);
    }
    return {
      lastSeenAt,
      action: wv.action || null, // "skip" | "watchLater"
    };
  };

  const shouldShowWorkshopVideo = (accountData) => {
    const { lastSeenAt, action } = getWorkshopVideoState(accountData);

    if (!lastSeenAt) return true;

    if (action === "skip") return false;

    // watchLater → show again after 1 day
    return Date.now() - lastSeenAt.getTime() >= ONE_DAY_MS;
  };

  if (typeof window !== "undefined") {
    disableDevtool();
  }

  const handleCloseWorkshopVideo = async (action = "skip") => {
    setShowWorkshopVideo(false);
    setIsWorkshopVideoMinimized(false);

    if (!account?.id) {
      console.error("[closeWorkshopVideo] account.id missing", account);
      return;
    }

    try {
      await updateDoc(doc(db, "account", account.id), {
        workshopVideo: {
          videoSrc: WORKSHOP_YOUTUBE_VIDEO_ID,
          lastSeenAt: serverTimestamp(),
          action, // "skip" or "watchLater"
        },
      });
    } catch (err) {
      console.error("Failed to save workshop video state:", err);
    }
  };

  const handleMinimizeWorkshopVideo = () => setIsWorkshopVideoMinimized(true);
  const handleExpandWorkshopVideo = () => setIsWorkshopVideoMinimized(false);

  useEffect(() => {
    if (account && Object.keys(account).length > 0) {
      setUserType("admin");
      setIsLoading(false);
    } else if (worker && Object.keys(worker).length > 0) {
      setUserType("worker");
      setIsLoading(false);
    } else if (!user) {
      setUserType(null);
      setIsLoading(false);
    }
  }, [account, worker, user]);

  const loadAdminData = async (userId) => {
    try {
      const productsQuery = query(
        collection(db, "products"),
        where("user", "==", userId),
      );
      const storeQuery = query(
        collection(db, "store"),
        where("user", "==", userId),
      );
      const ordersQuery = query(
        collection(db, "orders"),
        where("user", "==", userId),
        where("timeStamp", "<", current_timestamp),
        where("timeStamp", ">", oneWeekAgoTimestamp),
      );
      const transactionQuery = query(
        collection(db, "transaction"),
        where("user", "==", userId),
      );
      const notificationsQuery = query(
        collection(db, "notifications"),
        where("userId", "==", userId),
        where("timestamp", ">=", threeDaysAgo),
        orderBy("timestamp", "desc"),
        limit(20),
      );
      const digitalStoreQuery = query(
        collection(db, "digitalStore"),
        where("user", "==", userId),
      );
      const crossSellQuery = query(
        collection(db, "crossSell"),
        where("user", "==", userId),
      );

      const [
        productsSnapshot,
        storeSnapshot,
        ordersSnapshot,
        transactionSnapshot,
        notificationsSnapshot,
        digitalStoreSnapshot,
        crossSellSnapshot,
      ] = await Promise.all([
        getDocs(productsQuery),
        getDocs(storeQuery),
        getDocs(ordersQuery),
        getDocs(transactionQuery),
        getDocs(notificationsQuery),
        getDocs(digitalStoreQuery),
        getDocs(crossSellQuery),
      ]);

      const productsList = productsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch(
        fetchProducts(productsList.filter((product) => product.deleted !== 1)),
      );

      const storeList = storeSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch(fetchStore(storeList[0]));

      // Keep Redux in sync with Firestore: settings pages save with setDoc
      // but don't dispatch, so without this the next save anywhere writes
      // the stale login-time store back and wipes earlier edits.
      storeUnsubRef.current?.();
      storeUnsubRef.current = null;
      if (storeList[0]?.id) {
        storeUnsubRef.current = onSnapshot(
          doc(db, "store", storeList[0].id),
          (snap) => {
            if (snap.exists()) {
              dispatch(fetchStore({ id: snap.id, ...snap.data() }));
            }
          },
          (error) => console.error("Store listener error:", error),
        );
      }

      const ordersList = ordersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const filteredOrders = ordersList.filter((order) => order.deleted !== 1);
      dispatch(
        fetchOrders(
          filteredOrders
            .sort(function (a, b) {
              return b.timeStamp.seconds - a.timeStamp.seconds;
            })
            .map((item, index) => ({
              ...item,
              index: filteredOrders.length - index + 999,
            })),
        ),
      );

      const transactionsList = transactionSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const filteredTransactions = transactionsList.filter(
        (trans) => trans.deleted !== 1,
      );
      dispatch(
        fetchTransaction(
          filteredTransactions
            .sort(function (a, b) {
              return b.timeStamp.seconds - a.timeStamp.seconds;
            })
            .map((item, index) => ({
              ...item,
              index: filteredTransactions.length - index,
            })),
        ),
      );

      const notificationsList = notificationsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch(fetchNotification(notificationsList));

      const digitalStoreList = digitalStoreSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch(
        fetchDigitalStore(
          digitalStoreList.length > 0 ? digitalStoreList[0] : {},
        ),
      );

      const crossSellList = crossSellSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      dispatch(
        fetchCrossSell(crossSellList.length > 0 ? crossSellList[0] : {}),
      );
    } catch (error) {
      console.error("Error loading admin data:", error);
    }
  };

  const dhdFormAlert = async (userId) => {
    console.log("Checking DHD form for user:", userId);
    try {
      if (!userId) {
        setDhdFormDate(null);
        setDhdFormData(null);
        return;
      }

      const snap = await getDocs(
        query(
          collection(db, "dhd_form"),
          where("user", "==", userId),
          limit(1),
        ),
      );

      let data = null;
      let docId = null;

      if (!snap.empty) {
        docId = snap.docs[0].id;
        data = snap.docs[0].data();
      }

      if (data) {
        const resolvedTimestamp =
          data.updatedAt?.toDate?.() ||
          data.createdAt?.toDate?.() ||
          data.timestamp?.toDate?.() ||
          null;

        setDhdFormDate(resolvedTimestamp);
        setDhdFormData({ id: docId || userId, ...data });

        if (shouldShowDhdReminder({ id: docId || userId, ...data })) {
          setShowDhdReminder(true);
        } else {
          setShowDhdReminder(false);
        }
      } else {
        setDhdFormDate(null);
        setDhdFormData(null);
        setShowDhdReminder(false);
      }
    } catch (error) {
      console.error("Error loading dhd_form metadata", error);
      setDhdFormDate(null);
      setDhdFormData(null);
      setShowDhdReminder(false);
    }
  };

  const loadDhdWarnings = async (userId) => {
    if (!userId) {
      setActiveWarning(null);
      setWarningUserId(null);
      return;
    }
    try {
      const form = await getDhdForm(userId);
      const warning = pickActiveDhdWarning(form?.warnings);
      setActiveWarning(warning);
      setWarningUserId(userId);
    } catch (err) {
      console.error("Error loading DHD warnings:", err);
      setActiveWarning(null);
      setWarningUserId(null);
    }
  };

  const handleDhdReminderSkip = async () => {
    setShowDhdReminder(false);
    const uid =
      typeof user === "string" ? user : user?.uid || auth.currentUser?.uid;
    const docId = dhdFormData?.id || uid;
    if (!docId) return;

    try {
      await updateDoc(doc(db, "dhd_form", docId), {
        lastReminderAt: serverTimestamp(),
      });
      setDhdFormData((prev) =>
        prev ? { ...prev, lastReminderAt: new Date() } : prev,
      );
    } catch (err) {
      console.error("Failed to save DHD reminder skip:", err);
    }
  };

  const loadDhdFormMeta = async (userId) => {
    try {
      const dhdQuery = query(
        collection(db, "dhd_form"),
        where("user", "==", userId),
        where("acceptDHD", "==", true),
        where("pdfDownloaded", "==", true),
        orderBy("timestamp", "desc"),
        limit(1),
      );

      const snapshot = await getDocs(dhdQuery);

      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        const data = docSnap.data();
        const resolvedTimestamp =
          data.timestamp?.toDate?.() || data.createdAt?.toDate?.() || null;
        setDhdFormDate(resolvedTimestamp);
        setDhdFormData({
          id: docSnap.id,
          ...data,
        });
      }
    } catch (error) {
      console.error("Error loading dhd_form metadata", error);
      setDhdFormDate(null);
      setDhdFormData(null);
    }
  };

  const loadWorkerData = async (userId) => {
    try {
      // Orders
      const orders = await workerAPI.getOrders(
        oneWeekAgoTimestamp,
        current_timestamp,
      );
      dispatch(fetchOrders(orders));

      // Products
      const products = await workerAPI.getProducts();
      dispatch(fetchProducts(products));
      // Store
      const store = await workerAPI.getStore();
      dispatch(fetchStore(store));
      // Digital Store
      const digitalStore = await workerAPI.getDigitalStore();
      dispatch(fetchDigitalStore(digitalStore));

      const account = await workerAPI.getOwnerAccount();
      dispatch(fetchAccount(account));
      console.log("Worker data loaded successfully");
    } catch (error) {
      console.error("Error loading worker data:", error);
    }
  };

  const showDhdTimer =
    dhdFormDate && dhdFormData
      ? Date.now() < dhdFormDate.getTime() + 3 * 24 * 60 * 60 * 1000 &&
        dhdFormData.finished !== true
      : false;
  const dhdTimerDeadline = dhdFormDate
    ? new Date(dhdFormDate.getTime() + 3 * 24 * 60 * 60 * 1000)
    : null;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const accountQuery = query(
            collection(db, "account"),
            where("user", "==", user?.uid),
          );
          const accountSnapshot = await getDocs(accountQuery);

          if (!accountSnapshot.empty) {
            const accountData = accountSnapshot.docs[0].data();

            dispatch(
              fetchAccount({ id: accountSnapshot.docs[0].id, ...accountData }),
            );
            setUserType("admin");
            if (accountData.language) {
              localStorage.setItem("language", accountData.language);
            }
            await loadDhdFormMeta(user?.uid);
            await dhdFormAlert(user?.uid);
            await loadDhdWarnings(user?.uid);
            await loadAdminData(user?.uid);
            setIsLoading(false);

            if (shouldShowWelcomeVideo(accountData)) {
              setShowWelcomeVideo(true);
              hasCheckedWelcomeVideo.current = true;
            }

            if (shouldShowWorkshopVideo(accountData)) {
              setShowWorkshopVideo(true);
              hasCheckedWorkshopVideo.current = true;
            }
          } else {
            const workerQuery = query(
              collection(db, "workers"),
              where("user", "==", user?.uid),
            );
            const workerSnapshot = await getDocs(workerQuery);

            if (!workerSnapshot.empty) {
              const workerData = workerSnapshot.docs[0].data();
              dispatch(
                fetchWorker({ id: workerSnapshot.docs[0].id, ...workerData }),
              );
              await loadWorkerData(user?.uid);
              setUserType("worker");
              setIsLoading(false);
            } else {
              dispatch(logoutUser(""));
              localStorage.setItem("token", "");
              setIsLoading(false);
            }
          }
        } catch (error) {
          console.error("Error loading user data:", error);
          setIsLoading(false);
        }
      } else {
        storeUnsubRef.current?.();
        storeUnsubRef.current = null;
        dispatch(logoutUser(""));
        dispatch(fetchAccount(null));
        dispatch(fetchWorker(null));
        localStorage.setItem("token", "");
        setIsLoading(false);
        setActiveWarning(null);
        setWarningUserId(null);
      }
    });

    return () => {
      unsubscribe();
      storeUnsubRef.current?.();
      storeUnsubRef.current = null;
    };
  }, [user]);

  useEffect(() => {
    const onDhdStarted = (event) => {
      const at = event?.detail?.at ? new Date(event.detail.at) : new Date();
      setDhdFormDate(at);
      setDhdFormData((prev) => ({
        ...(prev || {}),
        acceptDHD: true,
        pdfDownloaded: true,
        finished: false,
      }));
    };

    window.addEventListener("dhd-registration-started", onDhdStarted);
    return () => {
      window.removeEventListener("dhd-registration-started", onDhdStarted);
    };
  }, []);

  // Routes for Admin
  const AdminRoutes = () => (
    <>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/products" element={<Products />} />
      <Route path="/insightads" element={<ProductsAi />} />
      <Route path="/Foorchat" element={<Foorchat />} />
      {/*<Route path="/foorcall" element={<Foorcall />} />*/}
      <Route path="/chat" element={<Chat />} />
      <Route path="/crossSell" element={<CrossSell />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/orders/digital" element={<DigitalOrders />} />
      <Route path="/Ordersabndn" element={<Ordersabndn />} />
      <Route path="/Ordersabndn/sheet" element={<OrdersAbndnSheet />} />
      <Route path="/orderProfile/:id" element={<OrderProfile />} />
      <Route path="/statistics" element={<OrderStatistics />} />
      <Route path="/profit-management" element={<ProfitManagement />} />

      <Route
        path="/digital-order-profile/:id"
        element={<DigitalOrderProfile />}
      />
      <Route path="/adduser" element={<Adduser />} />
      <Route path="/orders/OrderDetailsabndn" element={<OrderDetailsabndn />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/settings/account" element={<Account />} />
      <Route path="/settings/stock" element={<Stock />} />
      <Route path="/settings/store" element={<Store />} />
      <Route path="/digital/settings/store" element={<DigitalStore />} />
      <Route path="/digital/settings/form" element={<DigitalForm />} />
      <Route path="/settings/form" element={<Form />} />
      <Route path="/settings/SocialMedia" element={<SocialMedia />} />
      <Route
        path="/digital/settings/SocialMedia"
        element={<DigitalSocialMedia />}
      />
      <Route path="/settings/delevery" element={<Delevery />} />
      <Route path="/settings/services" element={<Services />} />
      <Route path="/digital/settings/services" element={<Services />} />
      <Route path="/settings/Shipcollect" element={<Shipcollect />} />
      <Route path="/settings/footer" element={<Footer />} />
      <Route path="/digital/settings/footer" element={<Footer />} />
      <Route path="/settings/OrderSettings" element={<OrderSettings />} />
      <Route
        path="/digital/settings/OrderSettings"
        element={<DigitalOrderSettings />}
      />
      <Route path="/settings/Country-Currency" element={<CountryCurrency />} />
      <Route path="/landing-page" element={<FoorAi />} />
      <Route path="/landing-page/editor" element={<Editor />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/plan" element={<Plan />} />
      <Route path="/digital/plan" element={<DigitalPlan />} />
      <Route path="/digital/settings/currency" element={<DigitalCurrency />} />
      <Route path="/ship" element={<Foorship />} />
      <Route path="/payment-methods" element={<PaymentMethodsPage />} />
      <Route path="/digital-sections" element={<DigitalSectionsPage />} />
      <Route path="/domains" element={<Domains />} />
      <Route path="/digital/domains" element={<Domains />} />
      <Route path="/FreeContent" element={<FreeContent />} />
      <Route path="/sawa9ly/:code" element={<Dashboard />} />
      <Route path="/workers-management" element={<WorkersManagement />} />
      <Route path="/special-offer" element={<SpecialOffer />} />
    </>
  );

  // Routes for Worker
  const WorkerRoutes = (worker) => {
    const permissions = worker.permissions || {};
    const canViewOrders = permissions["orders.view"] === true;
    const canViewStore = permissions["store.view"] === true;
    const canEditOrders = permissions["orders.update"] === true;
    const canDeleteOrders = permissions["orders.delete"] === true;
    const canEditStore = permissions["store.update"] === true;
    const canEditStoreDesign = permissions["store.updatedesign"] === true;
    const canViewProducts = permissions["products.view"] === true;
    const canEditProducts = permissions["products.update"] === true;
    const canAddOrder = permissions["orders.create"] === true;
    const canViewOrdersAbndn = worker.role === "partner";

    return (
      <>
        <Route path="/team/dashboard" element={<WorkerDashboard />} />

        {canViewOrders && (
          <>
            <Route path="/team/orders" element={<WorkerOrders />} />
            <Route
              path="/team/orderProfile/:id"
              element={<WorkerOrderProfile />}
            />
          </>
        )}
        {canViewOrdersAbndn && (
          <Route path="/team/Ordersabndn" element={<WorkerOrdersabndn />} />
        )}

        {canViewProducts && (
          <Route path="/team/products" element={<WorkerProducts />} />
        )}

        {canEditStore && canEditStoreDesign && (
          <Route path="/team/settings/store" element={<WorkerStore />} />
        )}

        {canEditProducts && (
          <Route path="/team/settings/stock" element={<WorkerStock />} />
        )}

        {<Route path="/team/settings" element={<WorkerSettingsPage />} />}
        {<Route path="/team/settings/account" element={<AccountWorker />} />}

        {/* <Route path="/team/profile" element={<WorkerProfile />} /> */}
      </>
    );
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <style>{`
          @keyframes logoPulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.2; transform: scale(0.85); }
          }
          @keyframes ripple {
            0% { transform: scale(0.8); opacity: 0.6; }
            100% { transform: scale(1.8); opacity: 0; }
          }
          .logo-pulse { animation: logoPulse 1.4s ease-in-out infinite; }
        
        `}</style>
        <div className="relative flex items-center justify-center w-32 h-32">
          <div className="ripple-ring" />
          <img
            src="/logo-new.png"
            alt={t("ui.logo")}
            width={300}
            height={300}
            className="logo-pulse relative z-10 object-contain"
          />
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <AIProductGenerationProvider>
        <div className="App dark:!bg-[#141414]" dir="rtl">
          <DeliveryCompanySync />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            newestOnTop
            closeOnClick
            pauseOnHover
            rtl
          />
          {user && (
            <FloatingDiscountTimerWrapper
              show={showDhdTimer}
              deadline={dhdTimerDeadline}
              dir={isRTL ? "rtl" : "ltr"}
              position={
                !isRTL
                  ? { top: "180px", right: 0, left: "auto" }
                  : { top: "180px", left: 0, right: "auto" }
              }
              onCountdownClick={() => setIsValidationModalOpen(true)}
            />
          )}
          {user && (
            <UploadValidationModal
              isOpen={isValidationModalOpen}
              setIsOpen={setIsValidationModalOpen}
              onClose={() => setIsValidationModalOpen(false)}
            />
          )}
          {/* {user && userType === "admin" && (
            <WelcomeVideoModal
              isOpen={showWelcomeVideo}
              onClose={handleCloseWelcomeVideo}
              isMinimized={isWelcomeVideoMinimized}
              onMinimize={handleMinimizeWelcomeVideo}
              onExpand={handleExpandWelcomeVideo}
            />
          )} */}

          {user && userType === "admin" && (
            <WorkshopVideoModal
              isOpen={showWorkshopVideo}
              onClose={handleCloseWorkshopVideo}
              isMinimized={isWorkshopVideoMinimized}
              onMinimize={handleMinimizeWorkshopVideo}
              onExpand={handleExpandWorkshopVideo}
            />
          )}
          {user && userType === "admin" && (
            <DhdReminderModalWrapper
              isOpen={showDhdReminder}
              onSkip={handleDhdReminderSkip}
            />
          )}

          {user && userType === "admin" && activeWarning && (
            <DhdWarningModal
              warning={activeWarning}
              userId={warningUserId}
              onDismissed={() => setActiveWarning(null)}
            />
          )}
          <GenerationOrbHost />
          <Routes>
            <Route
              path="*"
              element={
                <Navigate
                  to={
                    !user
                      ? "/login"
                      : userType === "admin"
                        ? "/dashboard"
                        : "/team/dashboard"
                  }
                />
              }
            />
            {user && userType === "admin" && AdminRoutes()}
            {user && userType === "worker" && WorkerRoutes(worker)}

            {!user && (
              <>
                <Route path="/login" element={<Login />} />
                <Route path="/sign-up" element={<Signup />} />
                <Route path="/reset-password" element={<Recover />} />
              </>
            )}
          </Routes>
        </div>
      </AIProductGenerationProvider>
    </BrowserRouter>
  );
}

export default App;
